module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "part"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "part_num"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/logo1.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("PART I")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "part_title"
  }, [_c('strong', [_vm._v("PEOPLE AND THINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "part_opner"
  }, [_c('p', {
    staticClass: "part_opner_text"
  }, [_c('em', [_vm._v("“Never before have the achievements of the industrial arts, the fine arts, and the sciences generally, shone with such lustre as gilds this epoch of the nineteenth century.”")])]), _vm._v(" "), _c('p', {
    staticClass: "part_opner_author"
  }, [_c('span', {
    staticClass: "textsmall"
  }, [_vm._v("—J. S. INGRAM, "), _c('em', [_vm._v("THE CENTENNIAL EXPOSITION, DESCRIBED AND ILLUSTRATED")]), _vm._v(" (1876)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_nts_r1#p01_fnt1",
      "id": "p01_fnt1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dis_img",
    attrs: {
      "id": "fig22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/22-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The cover of Frank Leslie’s Illustrated historical register of the Centennial Exposition of 1876. Columbia, goddess of Liberty (symbolizing America in red, white, and blue) reveals to figures representing Europe, Asia, and Africa (plus a submissively kneeling Native American) the wonders of American industry, commerce, and government, on display at the exposition.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215c6622","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454925767_epub_p01_r1.vue
// module id = 72
// module chunks = 0